import { Component, inject, Input } from '@angular/core';
import { AsyncPipe } from '@angular/common';

import { map } from 'rxjs';

import { AuthService } from '@app/core/services/auth/auth.service';
import { GeneAiUiModule } from "@gene-ai/ui/gene-ai-ui.module";

@Component({
  selector: 'app-user-avatar',
  imports: [
    AsyncPipe,
    GeneAiUiModule
  ],
  templateUrl: './user-avatar.component.html',
  styleUrl: './user-avatar.component.css',
  standalone: true
})
export class UserAvatarComponent {
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  private authService = inject(AuthService);

  readonly userInitials$ = this.authService.userData$.pipe(
    map(user => {
      if (!user.name || !user.name.trim()) {
        return "N/A";
      }

      const nameTokens = user.name.split(/[, ]+/).filter(Boolean);
      if (nameTokens.length === 0) return "N/A";

      const initials =
        nameTokens.length === 1
          ? nameTokens[0].charAt(0)
          : nameTokens[1].charAt(0) + nameTokens[0].charAt(0);

      return initials?.toUpperCase() || "N/A";
    })
  );
}
